<div class="black-bar">
  <lh-traveler-shops-ui-language-switcher height="30px" theme="dark"></lh-traveler-shops-ui-language-switcher>
  <lh-traveler-shops-ui-menu-button height="30px" theme="dark"></lh-traveler-shops-ui-menu-button>
</div>
